var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgrammingHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.9119 7.4929-14.6719 14.6717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4465 27.9356-7.2929 7.2928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4539 16.3263-8.5619 8.5619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2254 22.6021-12.4949 12.4948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.4127 34.5832c2.4354-2.4354 5.4808-8.44 12.99-8.44s10.8673-4.7757 10.8673-10.7769a10.871 10.871 0 0 0 -21.742-.0224l-.008 25.4134a2.7005 2.7005 0 0 0 1.3318 2.3862 2.6607 2.6607 0 0 0 3.991-2.3042v-12.9019"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingHero);
export default __webpack_public_path__ + "static/media/programming-hero.57b2709519f4e6dc7fa171257efb6398.svg";
export { ForwardRef as ReactComponent };